import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { Dashboard } from '../../../../../providers/bridge-api/dashboard.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-dashboard-option-permissions',
  templateUrl: './dashboard-option-permissions.component.html',
  styleUrls: ['./dashboard-option-permissions.component.scss'],
  standalone: false,
})
export class DashboardOptionPermissionsComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() dashboardOriginal: Dashboard;
  @Input() dashboard: Dashboard;
  @Input() isReadOnly: boolean;
  @Input() isHideVisible: boolean;
  @Input() exposedSave: () => Promise<void>;

  @Output() dashboardChanged = new EventEmitter<Dashboard>();

  public onExecutiveToggle(isExecutive: boolean) {
    this.dashboard.payload.isExecutive = isExecutive;
    this.dashboardChanged.emit(this.dashboard);
  }

  public onLockToggle() {
    this.dashboard.locked = !this.dashboard.locked;
    this.exposedSave();
  }

  public onHideToggle(hidden: boolean) {
    this.dashboard.visibility = hidden ? 'UNLISTED' : 'PUBLIC';
    this.dashboardChanged.emit(this.dashboard);
  }
}
